<template lang="pug">
  nav.header-social

    a(:href="network.url" v-for="(network, index) in config.socialnetworks" :key="index")
      font-awesome-icon(:icon="['fab', network.icon]")

</template>

<script>
  import { mapState } from 'vuex'

  export default  {
    name: 'header-social',
    computed: mapState([
      'config'
    ])
  }
</script>

<style scoped lang="scss">
  .header-social {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-bottom: 0.2rem;
    a{
      color: #1f2935;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 30px;
      height: 30px;
      border-radius: 30px;
      margin: 2px;
      border: 1px solid rgba(0,0,0,.2);
      position: relative;
      overflow: hidden;
      &:after{
        content: '';
        background-color:  rgba(0,0,0,.2);
        position: absolute;
        width: 100%;
        height: 100%;
        transform: scale(0);
        transition: transform .3s ease;
        border-radius: 20px;
      }
      &:hover{
        &:after{
          transform: scale(1);
        }
      }
    }
  }
</style>
